import { FC, useEffect, useState } from "react";
import { Outlet, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ValidateCodeReset } from "./Validation/validate";
import { ChrevonLeftIcon } from "../../components/MenuIcons/ChevrotLeft";
import { Footer } from "../../components/Footer/footer";
import { ResetPassword } from "./reset/reset";

const ResetLayout: FC = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const [show, setShow] = useState(true)



    function shouldShow() {
        const currentPath = location.pathname;
        const pathEnd = currentPath.substring(currentPath.lastIndexOf('/') + 1);

        if (pathEnd === 'success') {
            setShow(false)
        }
        else {
            setShow(true)
        }

    }

    useEffect(() => {
        shouldShow()
    }, [location.pathname])


    return (
        <div className="createPage">
            <div className="createContent">
                <div className="create">
                    <div className="back">
                        <ChrevonLeftIcon action={() => navigate(-1)} />
                    </div>
                    <Outlet />
                </div>
                {show && <Footer />}
            </div>
        </div>
    )
}

const ResetPage = () => {

    return (
        <Routes>
            <Route element={<ResetLayout />}>
                <Route path='/' element={<ValidateCodeReset />} />
                <Route path='/reset' element={<ResetPassword />} />
            </Route>
        </Routes>
    )
}

export { ResetPage }